import { useFeaturesReady } from "../context/featuresReady/FeaturesReadyContext";
import { CUSTOMER_ACCESS_PURCHASE } from "../constants";
import { getFeature } from "../utils/features";

export const useAppAdoptionFeatures = (customerAccess) => {
  const { areFeaturesReady } = useFeaturesReady();

  if (!areFeaturesReady || customerAccess !== CUSTOMER_ACCESS_PURCHASE) {
    return false;
  }

  return getFeature("eap-app-adoption").isEnabled();
};
